var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.fileurl != '')?_c('a-scene',{attrs:{"xr-mode-ui":"enabled: false"},on:{"loaded":_vm.onSceneLoaded}},[_c('a-entity',{ref:"camera",attrs:{"camera":"","look-controls":""}}),_c('a-sky',{attrs:{"src":_vm.fileurl}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }